import type { TProduct } from '../type'

import { useSiteSpecificContext } from '@/contexts/SiteSpecificContext'


import { useMemo } from 'react';
export function usePayBase({
  productPriceCredits,
}: {
  productPriceCredits: TProduct
}) {
  const { plan, usage, user } = useSiteSpecificContext()
  const { hasActivePlan, creditsPlan, planPlatformInfoEnable, hasPlan } = plan

  const { userId } = user

  const loading = useMemo(() => {
    return user.isInitialLoading || plan.loading
  }, [plan.loading, user.isInitialLoading])

  const currentPlan = plan?.currentPlan
  const isNormalUser = plan?.isNormalUser
  const isAbnormalUser = plan?.isAbnormalUser

  const canSubscription = useMemo(() => {
    if (!planPlatformInfoEnable) {
      return true
    }
    if (!productPriceCredits) {
      return true
    }
    if (!creditsPlan || !hasPlan) {
      return true
    }

    // upgrade on plan is disable
    if (!hasActivePlan) {
      return true
    }
    const currentUpgradeWeight = creditsPlan.productsSub?.upgradeWeight

    if (!currentUpgradeWeight) {
      return true
    }

    // must upgrade to the plus plan
    if (productPriceCredits.upgradeWeight < currentUpgradeWeight) {
      return false
    }
    return true
  }, [
    planPlatformInfoEnable,
    productPriceCredits,
    creditsPlan,
    hasPlan,
    hasActivePlan,
  ])

  return {
    currentPlan,
    canSubscription,
    isSignIn: user?.isSignIn ?? false,
    loading,
    isNormalUser,
    isAbnormalUser,
    userId,
    plan,
    usage,
  }
}
